import App from './App.svelte';
import { mount } from "svelte";

const app = mount(App, {
	target: document.querySelector('.svelte-main'),
	props: {
		name: 'from Svelte'
	}
});
